// FORM

class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.getSelectedOptions();
    this.getSelectedVariant();

    if (this.currentVariant) {
      this.updateURL();
      this.updateFormID();
      this.updatePrice();
      this.updateCTA();
      this.updateMedia();
      this.updateColor();
      this.updateTextColor();
      document.dispatchEvent(
        new CustomEvent('variant:change', {
          detail: {
            variant: this.currentVariant,
          },
        })
      );
    }
  }

  getSelectedOptions() {
    this.options = Array.from(this.querySelectorAll('.mm-product-variant-checkbox:checked'), (checkbox) => checkbox.value);
  }

  getVariantJSON() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getSelectedVariant() {
    this.currentVariant = this.getVariantJSON().find((variant) => {
      const findings = !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);

      if (findings) return variant;
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateFormID() {
    const form_input = document.querySelector('#product-form').querySelector('input[name="id"]');
    form_input.value = this.currentVariant.id;
  }

  updateMedia() {
    const mobileVariantImage = document.querySelector('.mm-mobile-variant-image');

    if (mobileVariantImage) {
      mobileVariantImage.src = document.querySelector('.mm-variant-image-' + this.currentVariant.id).value;
    }
  }

  updatePrice() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const id_sticky = `price-sticky-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const oldPrice = document.getElementById(id);
        const newPrice = html.getElementById(id);
        const oldPriceSticky = document.getElementById(id_sticky);
        const newPriceSticky = html.getElementById(id_sticky);

        if (oldPrice && newPrice) oldPrice.innerHTML = newPrice.innerHTML;
        if (oldPriceSticky && newPriceSticky) oldPriceSticky.innerHTML = newPriceSticky.innerHTML;
      });
  }

  updateColor() {
    const colorNameElement = document.querySelector('#variant-option-color');
    if (colorNameElement) {
      colorNameElement.textContent = this.options[0];
    }
  }

  updateTextColor() {
    var textPreview = document.querySelector('#engraving-text-preview');
    var classes = textPreview.classList;
    classes.forEach(function (className) {
      if (className.startsWith('engraving-text-color_')) {
        classes.remove(className);
      }
    });
    classes.add(`engraving-text-color_${this.options[0]}`);
  }

  updateCTA() {
    const CTAs = document.querySelectorAll('.mm-product-form-submit-button');
    if (this.currentVariant.available) {
      CTAs.forEach((CTA) => {
        CTA.classList.remove('mm-btn-disabled');
      });
    } else {
      CTAs.forEach((CTA) => {
        CTA.classList.add('mm-btn-disabled');
      });
    }
  }
}

customElements.define('variant-selector', VariantSelector);

// EngravedComponent

class EngravedCompo extends HTMLElement {
  constructor() {
    super();
    this.customizeBtn = this.querySelector('#engraving-btn');
    this.customizeBtnCheck = this.querySelector('input');
    this.customizationContainer = this.querySelector('#engraving-container');
    this.inputText = this.querySelector('#engraving-text');
    this.isExpanded = false;
    this.customSelect = this.querySelector('#engraving-text-font-select');
    this.selectedOption = this.customSelect.querySelector('.selected-option');
    this.selectOptions = this.customSelect.querySelector('.options');
    this.optionItems = this.customSelect.querySelectorAll('.option');
    this.textPreview = document.querySelector('#engraving-text-preview');
    this.selectedOrientation = this.querySelector('input[name="engraving-orientation"]:checked').value;
    this.selectedFont = this.querySelector('.engraving-text-font-select .selected-option').getAttribute('data-value');
    this.initEngravingInput();
    this.initSelectedOption();
    this.initEventsListener();
  }

  initEventsListener() {
    this.addEventListener('change', this.onVariantChange);

    this.customizeBtn.addEventListener('click', () => this.expandContainer());

    this.selectedOption.addEventListener('click', () => {
      this.selectOptions.style.display = this.selectOptions.style.display === 'block' ? 'none' : 'block';
      const currentHeight = this.customizationContainer.scrollHeight;
      const optionsHeight = this.selectOptions.getBoundingClientRect().height;
      if (this.selectOptions.style.display === 'block') {
        this.customizationContainer.style.maxHeight = `${currentHeight + optionsHeight}px`;
      } else {
        this.customizationContainer.style.maxHeight = `${currentHeight - optionsHeight}px`;
      }
    });

    this.optionItems.forEach((option) => {
      option.addEventListener('click', () => {
        this.selectedOption.childNodes[0].textContent = option.textContent;
        this.selectOptions.style.display = 'none';
        const selectedValue = option.getAttribute('data-value');
        const selectedFont = option.getAttribute('data-font');
        this.selectedOption.style.fontFamily = selectedFont;
        this.selectedOption.setAttribute('data-value', selectedValue);
        this.selectedOption.setAttribute('data-font', selectedFont);
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.customSelect.contains(e.target)) {
        this.selectOptions.style.display = 'none';
      }
    });

    window.addEventListener('load', () => this.adjustFontSize());
    window.addEventListener('resize', () => this.adjustFontSize());
  }

  onVariantChange() {
    this.getSelectedOptions();
    this.getSelectedVariant();

    // const DeliveryEstimationClass = document.querySelector('delivery-estimation');
    // DeliveryEstimationClass.estimateDeliveryDelay(this.currentVariant.id);

    if (this.currentVariant) {
      this.updateURL();
      this.updateFormID();
      this.updatePrice();
      this.updateCTA();
      this.updateMedia();
      this.updateColor();
      this.updateTextColor();
    }
  }

  getSelectedOptions() {
    const variantSelectorElement = document.querySelector('variant-selector');
    this.options = Array.from(
      variantSelectorElement.querySelectorAll('.mm-product-variant-checkbox:checked'),
      (checkbox) => checkbox.value
    );
  }

  getVariantJSON() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getSelectedVariant() {
    this.currentVariant = this.getVariantJSON().find((variant) => {
      const findings = !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);

      if (findings) return variant;
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateFormID() {
    const form_input = document.querySelector('#product-form').querySelector('input[name="id"]');
    form_input.value = this.currentVariant.id;
  }

  updateCTA() {
    const CTAs = document.querySelectorAll('.mm-product-form-submit-button');
    if (this.currentVariant.available) {
      CTAs.forEach((CTA) => {
        CTA.classList.remove('mm-btn-disabled');
      });
    } else {
      CTAs.forEach((CTA) => {
        CTA.classList.add('mm-btn-disabled');
      });
    }
  }

  updateMedia() {
    const mobileVariantImage = document.querySelector('.mm-mobile-variant-image');
    const variantImages = document.querySelectorAll('#variant_media');

    if (mobileVariantImage) {
      mobileVariantImage.src = document.querySelector('.mm-variant-image-' + this.currentVariant.id).value;
      const variantMedias = document.querySelectorAll('.variant-medias-' + this.currentVariant.id);
      if (variantMedias) {
        variantImages.forEach((media, index) => {
          const altValue = media.alt;
          const altParts = altValue.split('_');
          const altWithoutFirstPart = altParts.slice(1).join('_');
          const matchingMedia = Array.from(variantMedias).find((element) => element.getAttribute('data-alt') === altWithoutFirstPart);
          if (matchingMedia) {
            media.src = matchingMedia.value;
          }
        });
      }
    }
  }

  updatePrice() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const id_sticky = `price-sticky-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const oldPrice = document.getElementById(id);
        const newPrice = html.getElementById(id);
        const oldPriceSticky = document.getElementById(id_sticky);
        const newPriceSticky = html.getElementById(id_sticky);
        if (oldPrice && newPrice) oldPrice.innerHTML = newPrice.innerHTML;
        if (oldPriceSticky && newPriceSticky) oldPriceSticky.innerHTML = newPriceSticky.innerHTML;
      });
  }

  updateColor() {
    const colorNameElement = document.querySelector('#variant-option-color');
    if (colorNameElement) {
      colorNameElement.textContent = this.options[0];
    }
  }

  updateTextColor() {
    var classes = this.textPreview.classList;
    classes.forEach(function (className) {
      if (className.startsWith('engraving-text-color_')) {
        classes.remove(className);
      }
    });
    classes.add(`engraving-text-color_${this.options[0]}`);
  }

  initEngravingInput() {
    const inputContainer = this.querySelector('#engraving-text-container');
    const options = inputContainer.querySelectorAll('.mm-product-variant-checkbox');
    const checkboxElement = this.querySelector('#engraving-checkbox');
    const inputTextProperty = this.querySelector('#engraving-text-property');
    const radioOptions = document.querySelectorAll('input[name="engraving-orientation"]');
    const customSelect = document.querySelector('#engraving-text-font-select');
    const optionItems = customSelect.querySelectorAll('.option');

    if (this.inputText) {
      this.inputText.addEventListener('input', () => {
        inputTextProperty.textContent = this.inputText.value.trim();
        this.textPreview.textContent = this.inputText.value.trim();
        this.adjustFontSize();
      });
    }

    if (checkboxElement) {
      checkboxElement.addEventListener('change', async () => {
        for (const option of options) {
          if (
            (checkboxElement.checked == false && option.value === 'Sans gravure') ||
            (checkboxElement.checked == true && option.value === 'Avec gravure')
          ) {
            option.checked = true;
          } else {
            option.checked = false;
          }
        }

        await new Promise((resolve) => setTimeout(resolve, 0));
        this.onVariantChange();
      });
    }

    radioOptions.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        this.selectedOrientation = radio.value;
        this.selectedOrientation == 'vertical'
          ? this.textPreview.classList.remove('horizontal')
          : this.textPreview.classList.add('horizontal');
        this.adjustFontSize();
      });
    });

    optionItems.forEach((option) => {
      option.addEventListener('click', () => {
        this.selectedFont = option.getAttribute('data-value');
        this.textPreview.style.fontFamily = option.getAttribute('data-font');
        this.adjustFontSize();
      });
    });
  }

  expandContainer() {
    const event = new Event('change');
    if (this.isExpanded) {
      this.customizationContainer.style.maxHeight = '0';
      this.customizeBtnCheck.checked = false;
      this.customizeBtnCheck.dispatchEvent(event);
      this.inputText.value = '';
      this.triggerInputEvent(this.inputText);
      this.textPreview.style.display = 'none';
    } else {
      this.customizationContainer.style.maxHeight = `${this.customizationContainer.scrollHeight}px`;
      this.customizeBtnCheck.checked = true;
      this.customizeBtnCheck.dispatchEvent(event);
      this.textPreview.style.display = 'block';
    }
    this.isExpanded = !this.isExpanded;
  }

  triggerInputEvent(element) {
    const event = new Event('input', {
      bubbles: true,
      cancelable: true,
    });
    element.dispatchEvent(event);
  }

  initSelectedOption() {
    var defaultOption = this.customSelect.querySelector('.option.selected');
    this.selectedOption.childNodes[0].textContent = defaultOption.textContent;
    this.selectedOption.setAttribute('data-value', defaultOption.getAttribute('data-value'));
    this.selectedOption.setAttribute('data-font', defaultOption.getAttribute('data-font'));
  }

  adjustFontSize() {
    var parentWidth = document.querySelector('#main-slider').querySelector('.splide__list').offsetWidth;
    var fontSize = 0.04 * parentWidth;
    var fontWeight = 'bold';
    if (this.selectedFont != 'comfortaa' && this.selectedFont != 'times') {
      fontSize = fontSize * 1.1;
      fontWeight = 'normal';
    }
    if (this.selectedFont == 'times') {
      fontSize = fontSize * 0.9;
      fontWeight = 'normal';
    }
    if (this.selectedOrientation == 'horizontal') {
      if (this.inputText.value.length > 10) {
        var reductionFactor = 1.25 + (this.inputText.value.length - 10) * 0.15;
        fontSize = fontSize / reductionFactor;
      } else fontSize = fontSize / 1.25;
    }
    this.textPreview.style.fontSize = fontSize + 'px';
    this.textPreview.style.fontWeight = fontWeight;
  }
}

customElements.define('engraved-compo', EngravedCompo);
